<template>
  <v-container fluid>
    <v-card 
      class="mx-auto"
      style="margin-bottom: 10px;"
      outlined
    >
      <v-container fluid>
        <div class="chip_box2">
          <div>
            <v-btn
              color="#78909C"
              style="margin:10px 7px 10px 10px;"
              outlined
              @click="dialogHandler2('addUser')"
            >
              <v-icon
                style="margin-right:5px;"
              >
                mdi-account-plus
              </v-icon>Add User
            </v-btn>
            <v-btn
              color="#78909C"
              style="margin:10px 7px 10px 10px;"
              outlined
              @click="$router.push({ name: 'CompanyList' })"
            >
              <v-icon
                style="margin-right:5px;"
              >
                mdi-domain
              </v-icon>Company List
            </v-btn>
          </div>
          <div>
            <v-btn
              color="#78909C"
              style="margin:10px 7px 10px 10px;"
              outlined
              @click="$router.push({ name : 'Order' })"
            >
              <v-icon
                style="margin-right:5px;"
              >
                mdi-arrow-left
              </v-icon>Order List
            </v-btn>
            <v-btn
              color="#78909C"
              style="margin:10px 7px 10px 10px;"
              outlined
              @click="dialogHandler2('modify')"
            >
              <v-icon
                style="margin-right:5px;"
              >
                mdi-content-save
              </v-icon>Save
            </v-btn>
          </div> 
        </div>
      </v-container>
    </v-card>
    <v-card
      outlined
    >
      <v-card-text>
        <v-progress-linear
          indeterminate
          color="#78909C"
          :active="progress"
        />
        <grid
          ref="grid"
          :data="gridProps.data"
          :columns="gridProps.columns"
          :options="gridProps.options"
          :theme="gridProps.myTheme"
          :columnOptions="gridProps.columnOptions"
          :bodyHeight="gridProps.bodyHeight"
          @click="onClick"
        />
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="addDialog"
      :persistent="!isModify"
      width="512"
    >
      <v-card>
        <v-toolbar
          flat
          dark
          color="#78909C"
        >
          <v-toolbar-title>User Profile</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn
              icon
              dark
              @click="addDialog = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
          <v-menu
            bottom
            right
            offset-y
          />
        </v-toolbar>
        <v-card-text style="padding-bottom:0px;">
          <v-form
            ref="form"
            lazy-validation
            style="margin-top:20px;"
          >
            <div style="display:flex;justify-content: center;">
              <div style="width:400px;margin:40px 20px">
                <v-card
                  outlined
                  style="padding:30px;"
                >                
                  <v-text-field
                    v-if="!isModify"
                    ref="userId"
                    v-model="formData.userId"
                    label="User ID*"
                    required
                    :rules="idRules"
                    maxlength="20"
                    :disabled="preventAutocomplete"
                  />
                  <v-text-field
                    v-else
                    ref="userId"
                    v-model="formData.userId"
                    label="User ID*"
                    required
                    maxlength="50"
                    disabled
                  />
                  <v-text-field
                    v-model="formData.userName"
                    label="User Name*"
                    hint="example) 홍길동"
                    :rules="[rules.required]"
                    maxlength="10"
                    :disabled="preventAutocomplete"
                  />
                  <v-text-field
                    v-model="formData.phone"
                    label="Tel.no"
                    required
                    persistent-hint
                    maxlength="14"
                    :disabled="preventAutocomplete"
                  />
                  <v-text-field
                    v-model="formData.email"
                    label="E-mail*"
                    maxlength="40"
                    :rules="[rules.email]"
                    :disabled="preventAutocomplete"
                  />
                  <v-autocomplete
                    v-model="formData.company_id"
                    style="margin-top:30px;"
                    :items="companyItems"
                    label="Company"
                    item-text="text"
                    item-value="value"
                    required
                    dense
                    :rules="rules.select"
                    :disabled="preventAutocomplete"
                    aria-autocomplete="both"
                  />
                  <div v-show="!isModify">
                    <div style="margin-top:50px;">
                      <v-text-field
                        v-model="formData.password"
                        label="Password"
                        type="password"
                        :rules="passwordRulesCurrent"
                        :disabled="preventAutocomplete"
                      />
                      <v-text-field
                        v-model="formData.confirm"
                        label="Confirm"
                        type="password"
                        :rules="passwordRules"
                        :disabled="preventAutocomplete"
                      />
                    </div>
                  </div>
                </v-card>
                <small><b>* indicates required field</b></small>
              </div>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions style="padding-top:0px;">
          <v-spacer />
          <v-btn
            color="#78909C"
            style="margin:10px 7px 10px 10px;"
            outlined
            @click="dialogHandler2('dialogCancel')"
          >
            Cancel
          </v-btn>
          <v-btn
            v-if="!isModify"
            color="#78909C"
            style="margin:10px 7px 10px 10px;background-color: aliceblue;"
            outlined
            @click="modifyRow(formData, 'create')"
          >
            Add Profile
          </v-btn>
          <v-btn
            v-else
            color="#78909C"
            style="margin:10px 7px 10px 10px;background-color: aliceblue;"
            outlined
            @click="modifyRow(formData, 'update')"
          >
            Update Profile
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="300"
      @keydown.enter="eventHandler(trigger)"
    >
      <v-card>
        <v-toolbar
          flat
          dark
          color="#78909C"
          dense
          style="height:40px;"
        >
          Message
        </v-toolbar>
        <v-sheet class="px-7 pt-7 pb-4 mx-auto text-center">
          <div class="text-body-2 mb-4">
            {{ dialogMessage }}
          </div>
          <v-btn
            class="ma-1"
            plain
            color="error"
            @click="dialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            class="ma-1"
            color="primary"
            plain
            :loading="loading"
            @click="eventHandler(trigger)"
          >
            OK
          </v-btn>
        </v-sheet>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackBar"
    >
      {{ snackBarText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="pink"
          text
          v-bind="attrs"
          @click="snackBar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import 'tui-grid/dist/tui-grid.css'
import { Grid } from '@toast-ui/vue-grid'
import 'tui-date-picker/dist/tui-date-picker.css';
import 'tui-time-picker/dist/tui-time-picker.css';
import moment from "moment-timezone";
import crypto from 'crypto-js'
import Inko from 'inko'
import { secretKey } from '@/config/config'
import _ from 'lodash';

var CustomText = function(props) {
  let div = document.createElement("div");
  var el = document.createElement("button");
  const manager = props.grid.store.data.rawData[props.rowKey].manager
  const level = props.grid.store.data.rawData[props.rowKey].level
  if (props.formattedValue == "") {
    el.innerHTML =
    '<span class="v-btn__content"><i aria-hidden="true" style="margin-left:23px;" class="v-icon notranslate v-icon--left mdi mdi-playlist-edit bla--text text--darken-2 theme--light" style="font-size: 20px;"></i></span>';
  } else {
    if (level == 1 && manager != 1) {
      el.innerHTML =
      `<span class="v-btn__content"><b style="color:#1E88E5">&nbsp;&nbsp;&nbsp;${props.value}</b><span style="color:#D50000;margin-left:3px;">(Administrator)</span></span>`;
    } else {
      el.innerHTML =
      `<span class="v-btn__content"><b style="color:#1E88E5;">&nbsp;&nbsp;&nbsp;${props.value}</b></span>`;
    }
  }

  const { grid, rowKey, columnInfo } = props;
  el.addEventListener("click", () => {});
  el.style.width = "calc(100% - 10px)";
  el.style.margin = "4px 0px 0px 0px";
  div.appendChild(el);

  this.el = div;
  this.render(props);
};

CustomText.prototype.getElement = function() {
  return this.el;
};
CustomText.prototype.getValue = function() {
  return this.el.value;
};
CustomText.prototype.render = function(props) {
  this.el.value = props.value;
};



class CustomTextEditor {
  constructor(props) {
    const el = document.createElement('input');
    const { maxLength } = props.columnInfo.editor.options;

    el.type = 'text';
    el.maxLength = maxLength;
    el.value = String(props.value);

    this.el = el;
  }

  getElement() {
    return this.el;
  }

  getValue() {
    return this.el.value;
  }

  mounted() {
    this.el.select();
  }
}


export default {
  components: {
    grid: Grid
  },
  data: () => ({
    preventAutocomplete: false,
    loading: false,
    isModify: false,
    positionItems: [],
    items:[],
    companyItems: [],
    companyItemsReverse: [],
    departmentItems: [],
    addDialog: false,
    rules: {
      select: [(v) => !!v || "Please select an item"],
      required: value => !!value || "Please enter a value",
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid email format.";
      },      
    },
    formData: {
      userId: '',
      userName: '',
      phone: '',
      email: '',
      password: '',
      confirm: '',
      company_id: '',
      departmentId: '',
      official: '',
      position: '',
    },
    progress: false,
    sheetRowCount: 0,
    isSelecting: false,

    sampleDialog: false,
    dialog : false,
    dialogMessage : '',
    snackBar : false,
    snackBarText : '',
    text : '',
    trigger : '',
    companies : [],
    // classification : [],
    // type : [],
    // ampliconSeq : [],
    // genomeSeq : [],
    
    gridProps: {
      bodyHeight: 700,
      pageOptions: {
        useClient: true,
        type: 'scroll',
        perPage: 50
      },

      columnOptions: {
        resizable: true,
        frozenCount: 1
      },
      columns: [],  
      data: [],
      myTheme: {
        name: 'myTheme',
        value: {
          cell: {
            normal: {
              background: '#fff',
              border: '#e0e0e0',
              showVerticalBorder: false,
              showHorizontalBorder: true
            },
            header: {
              background: '#e0e0e0',
              border: '#e0e0e0'
            },
            selectedHeader: {
              background: '#e0e0e0'
            }
          }
        }
      },
      myTheme: {
        name: "myTheme",
        value: {
          row: {
            even: {},
            hover: {
              background: '#EEEEEE'
            }
          },
          cell: {
            normal: {
              background: '#FFFFFF',
            },
            header: {
            },
            rowHeader: {
            },
            editable: {
            },
            selectedHeader: {
            },
            focused: {
              border: '#eeeeee'
            },
            disabled: {
            }
          }
        }
      },
      options: {
        rowHeaders: ['rowNum']
      }
     },
     levelList: [
      {text : '학술분석고객', value: '0'},
      {text : '관리자', value: '1'},
      {text : '리포트고객', value: '2'},
      {text : '마이크로바이옴수주고객', value: '3'},
      {text : '질병청고객', value: '4'},
    ]
  }),
  computed: {
    passwordRulesCurrent() {
      return [
        value => !!value || 'Password is required',
        value => (value && value.length >= 8) || 'Password must be at least 8 characters',
        value => /[!@#$%^&*()_+[\]{};':"\\|,.<>/?]+/.test(value) || 'Password must contain special characters',
      ];
    },
    idRules () {
      const rules = []
      const rule = v => !!v || 'Please enter your ID'
      rules.push(rule)
      const dupRule = v => !this.isDuple(v) || 'ID already registered.'
      rules.push(dupRule)
      return rules
    },
    passwordRules() {
      return [
        value => !!value || 'Password is required',
        value => (value && value.length >= 8) || 'Password must be at least 8 characters',
        value => /[!@#$%^&*()_+[\]{};':"\\|,.<>/?]+/.test(value) || 'Password must contain special characters',
        value => value === this.formData.password || 'Passwords do not match',
      ];
    },
  },
  created() {
    
  },
  async mounted() {
    this.progress = true;
    await this.initData();
    // await this.codeSearch();
    await this.initColumn();
  },
  methods : {
    async onClick(ev) {
      this.checkedRows = this.$refs.grid.invoke("getCheckedRows");
      if (ev.targetType == 'cell') {
        let columnName = ev.columnName;
        this.selectedRowData = this.$refs.grid.invoke("getData").filter(v => v.rowKey == ev.rowKey)[0];
        if (columnName == "userId") {
          this.dialogHandler2('updateUser')
        }
      }
    },
    dialogHandler2(event) {
      this.$refs.grid.invoke("blur");
      this.formData = {}
      this.isModify = false;
      if (event == 'addUser') {
        this.preventAutocomplete = true; // 자동입력 방지
        setTimeout(() => {
          this.addDialog = true;          
        }, 100);
        setTimeout(() => {
          this.preventAutocomplete = false;
        }, 1000);
      } else if (event == 'dialogCancel') {
        this.addDialog = false;
      } else if (event == 'updateUser') {
        this.isModify = true;
        this.formData = this.selectedRowData;
        this.addDialog = true;
      } else if (event == "modify") {
        const modifieds = this.$refs.grid.invoke("getModifiedRows");
        let validate = this.$refs.grid.invoke('validate');
        if (modifieds.createdRows.length != 0 || modifieds.updatedRows.length != 0 || modifieds.deletedRows.length != 0) {
          if(validate.length == 0){
            if(this.isDuple() == false){
              this.dialog = true
              this.dialogMessage = "Would you like to save the changes?"
              this.trigger = 'modify';
            }else{
              this.snackBar = true;
              this.snackBarText = 'ID already registered.';
              // this.text = this.isDuple().join('<br>');
              return false;
            }
          }else{
            this.snackBar = true;
            this.snackBarText = 'Please check the entered value.'
            return false;
          }
        }else{
          this.snackBar = true;
          this.snackBarText = 'No changes have been made.';
          return false;
        }
      }
    },
    modifyRow(formData, event) {
      let data = formData;      
      
      if (event == 'create') {
        const vali = this.$refs.form.validate();
        if (vali) {
          let inko = new Inko();
          data.class = 'Client'
          data.companyName = data.companyId ? this.companyItems.find(v => v.value == data.companyId).name : ''
          // data.departmentName = data.departmentId ? this.departmentItems.find(v => v.value == data.departmentId).text : ''
          data.usedCode = data.usedCode == 'Used' ? 1 : 0;
          data.confirm = "";
          let password = inko.ko2en(data.password);
          password = crypto.AES.encrypt(password, secretKey).toString();
          data.password = password;
          this.$refs.grid.invoke("appendRow", data);
          this.$refs.grid.invoke("focus", this.gridProps.data.length, "userId", true);
        } else {
          this.snackBarText = "Please check the information you entered again."
          this.snackBar = true
          return false;
        }
      } else if (event == 'update') {
        data.companyName = data.companyId ? this.companyItems.find(v => v.value == data.companyId).name : ''
        // data.departmentName = data.departmentId ? this.departmentItems.find(v => v.value == data.departmentId).text : ''
        data.usedCode = data.usedCode == 'Used' ? 1 : 0;
        data.confirm = "";
        this.$refs.grid.invoke("setRow", this.selectedRowData.rowKey, this.formData);
        this.$refs.grid.invoke("focus", this.selectedRowData.rowKey, "userId", true);
      }
      this.addDialog = false;
      this.formData = { 
        userId: '',
        userName: '',
        phone: '',
        email: '',
        password: '',
        confirm: '',
        companyId: '',
        departmentId: '',
        official: '',
        position: ''
      }
      return false;
    },
    processingDate(date, noTime) {
      let day = ''
      if (date) day = moment(date).format("YYYY-MM-DD")
      return day;
    },
    initColumn(){
      let columns = [
        {
          header: 'Account Type',
          name: 'class',
          rowSpan: true,
          width: 130,
          align: 'center'
        },
        {
          header: 'ID',
          name: 'userId',
          align: 'center',
          width: 180,
          renderer: {
            type: CustomText
          },
        },
        {
          header: 'Name',
          name: 'userName',
          align: 'center',
          editor: {
            type: 'text',
            options: {
              maxLength: 10
            }
          }
        },
        {
          header: 'Company',
          name: 'company_id',
          align: 'center',
          formatter: 'listItemText',
          width: 250,
          editor: {
            type: 'select',
            options: {
              listItems: this.companyItemsReverse
            }
          }
        },
        {
          header: 'Department',
          name: 'department',
          align: 'center',
          width: 250,
          editor: {
            type: 'text',
            options: {
              maxLength: 20
            }
          }
        },
        {
          header: 'Official',
          name: 'official',
          align: 'center',
          editor: {
            type: 'text',
            options: {
              maxLength: 20
            }
          }
        },
        {
          header: 'Position',
          name: 'position',
          align: 'center',
          editor: {
            type: 'text',
            options: {
              maxLength: 20
            }
          }
        },
        {
          header: 'Level',
          name: 'level',
          align: 'center',
          formatter: 'listItemText',
          width: 100,
          editor: {
            type: 'select',
            options: {
              listItems: this.levelList
            }
          }
        },
        {
          header: 'Phone',
          name: 'phone',
          align: 'center',
          editor: {
            type: 'text',
            }
        },
        {
          header: 'Registration Date',
          name: 'createDate',
          align: 'center',
        },
      ]
      this.$refs.grid.invoke('setColumns',columns);
    },
    async initData() {
      try {
        const result = await this.$axios.get(`${this.$apiHost}/users/`);
        if (result.statusText === 'OK') {
          for (const i of result.data.userList) {
            if(i.company_id != null){
              i.company_id = i.company_id.toString();
            }
            if(i.level != null){
              i.level = i.level.toString();
            }
            i.createDate = this.processingDate(i.createDate);
          }
          result.data.userList = _.sortBy(result.data.userList, ['class','createDate']);
          this.gridProps.data = result.data.userList;
          
          this.companyItems = result.data.companyItems.map(({ name, value }) => ({
            text: name,
            value: value.toString(),
          }));
          this.companyItemsReverse = result.data.companyItems.map(({ name, value }) => ({
            text: name,
            value: value.toString(),
          }));
          this.$refs.grid.invoke("resetData", result.data.userList);
          this.progress = false;
        }          
      } catch (error) {
        console.error(error);
      } finally {
        return false;
      }
    },
    eventHandler(event) {
      if (event == "modify") {
        this.modifyUser();
      }
    },
    isDuple(data) {
      let originData = this.gridProps.data;
      const isDuplicate = originData.some(
        (user) =>
        user.userId === data
      );
      if (isDuplicate && this.addDialog) {
        this.$refs.userId.error = true;
        this.snackBar = true;
        this.snackBarText = 'ID already registered.';
        return true;
      }
      return false;
    },
    async modifyUser() {
      this.loading = true;
      try {
        let modifieds = this.$refs.grid.invoke("getModifiedRows");
  
        const params = {
          modifieds: modifieds
        };

        const result = await this.$axios.post(`${this.$apiHost}/users/modify`, params);
        if (result.statusText === 'OK') {
          this.initData();
          this.dialog = false;
          this.loading = false;
          this.snackBar = true;
          this.snackBarText = 'Your changes have been saved.';
        }
      } catch (err) {
        console.error(err)
        this.loading = false;
      } finally {
        return false;
      }
    }
  }
}
</script>

<style scoped>
.title_box {
  display:flex;
  justify-content:space-between;
}
.chip_box {
  display: flex;
  justify-content: flex-start;
  z-index: 100;
}
.chip_box.on {
  display: flex;
  justify-content: flex-start;
  width: 35vw;
  z-index: 100;
}
.chip_box2 {
  display: flex;
  justify-content: space-between;
  margin: -8px 0px;
}
.chip {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 200px;
}
.chip_title {
  font-weight:500;
  font-size:15px;
  color:#757575;
}
.select_box {
  width:600px;
  margin: 3px 0px -25px 10px !important;
  font-size:15px !important;
}
</style>
